import { bl_ppl_ap_participant_registration_hdr_RowClass } from '../../../dbschema/bl_ppl_ap_participant_registration_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class PeppolApParticipantRegistrationHdrContainerModel extends BaseContainerModel {
    bl_ppl_ap_participant_registration_hdr: bl_ppl_ap_participant_registration_hdr_RowClass = new bl_ppl_ap_participant_registration_hdr_RowClass();
}